import type {User} from "~/repository/types";
import type {Ref} from "vue";

export const useUserAPI = (user: Ref<User>) => {
    const {$api} = useNuxtApp()
    const {sendEvent} = useEventLogger();
    const {isLoggedIn} = useAuthStore()

    async function follow() {
        if (!isLoggedIn) {
            throw createError({
                statusCode: 401
            })
        }
        const profile = await $api.profile.follow(user.value.id)
        user.value.is_following = profile.is_following
        user.value.is_followed = profile.is_followed
        user.value.stats.followers = profile.stats.followers
        await sendEvent("USER_FOLLOW", user.value.id);
    }

    async function unfollow() {
        const profile = await $api.profile.unfollow(user.value.id)
        user.value.is_following = profile.is_following
        user.value.is_followed = profile.is_followed
        user.value.stats.followers = profile.stats.followers
        await sendEvent("USER_UNFOLLOW", user.value.id);
    }


    return {
        follow,
        unfollow
    }
}